import dissocPath from 'ramda/src/dissocPath'

import { DISSOC_SHARE_URL } from 'root/src/client/logic/static/actionIds'

export default {
	[DISSOC_SHARE_URL]: dissocPath(['staticData', 'shareUrl']),
}
